export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-d4cb063120f3b199576da73f51fb207a.png";